export function initPlusGrid() {
  const grids = document.querySelectorAll(".js-plus-grid");

  if (!grids.length) return;

  // Throttle function to limit the number of calculations
  const throttle = (func, limit) => {
    let inThrottle;
    return function (e) {
      if (!inThrottle) {
        func(e);
        inThrottle = true;
        setTimeout(() => (inThrottle = false), limit);
      }
    };
  };

  // Mouse movement handler for parallax effect
  // document.addEventListener(
  //   "mousemove",
  //   throttle((e) => {
  //     const mouseX = (e.clientX - window.innerWidth / 2) * 0.02;
  //     const mouseY = (e.clientY - window.innerHeight / 2) * 0.02;

  //     grids.forEach((grid) => {
  //       grid.style.setProperty("--move-x", `${mouseX}px`);
  //       grid.style.setProperty("--move-y", `${mouseY}px`);
  //     });
  //   }, 16)
  // ); // ~60fps

  // Update mask position for each plus grid
  const updateMask = (e) => {
    grids.forEach((grid) => {
      const rect = grid.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;

      requestAnimationFrame(() => {
        grid.style.setProperty("--mouse-x", `${x}%`);
        grid.style.setProperty("--mouse-y", `${y}%`);
      });
    });
  };

  document.addEventListener("mousemove", updateMask);
}
